import { generateCSS } from '../styles';

const SPELLING_COLOR = '#e81123';
const GRAMMAR_COLOR = '#2b62d9';

const genMarkStyles = color => ({
  textDecorationLine: 'underline',
  textDecorationStyle: 'wavy',
  textDecorationColor: color,
  textDecorationSkipInk: 'none',
  textUnderlineOffset: '3px'
});

const styleGenerator = theme => ({
  container: generateCSS({
    position: 'relative',
    width: '100%'
  }),

  // Text metrics, padding & size are synced from the textarea at runtime (see `syncBackdrop`)
  backdrop: generateCSS({
    position: 'absolute',
    top: '0',
    left: '0',
    margin: '0',
    boxSizing: 'border-box',
    overflow: 'hidden',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    color: 'transparent',
    borderColor: 'transparent',
    backgroundColor: theme.colors.base,
    pointerEvents: 'none',
    userSelect: 'none'
  }),

  // `!important` is needed to override the Input's glamor class this textarea also carries
  textarea: generateCSS({
    position: 'relative',
    zIndex: 1,
    boxSizing: 'border-box !important',
    backgroundColor: 'transparent !important',
    overflowWrap: 'break-word',
    wordWrap: 'break-word'
  }),

  spellingMark: generateCSS(genMarkStyles(SPELLING_COLOR)),

  status: generateCSS({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: '4px',
    ...theme.fonts.default,
    fontSize: '13px',
    color: theme.colors.primary,
    ' > span': {
      marginRight: '12px'
    }
  }),

  statusSpelling: generateCSS({
    color: SPELLING_COLOR,
    fontWeight: 'bold'
  }),

  statusGrammar: generateCSS({
    color: GRAMMAR_COLOR,
    fontWeight: 'bold'
  }),

  grammarMark: generateCSS(genMarkStyles(GRAMMAR_COLOR)),

  menu: generateCSS({
    position: 'fixed',
    zIndex: 10000,
    minWidth: '200px',
    maxWidth: '320px',
    padding: '4px 0',
    backgroundColor: theme.colors.base,
    border: `1px solid ${theme.colors.quaternary}`,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
    ...theme.fonts.default,
    fontSize: '14px',
    color: theme.colors.secondary
  }),

  menuHeader: generateCSS({
    display: 'flex',
    flexDirection: 'column',
    padding: '4px 12px 6px',
    fontSize: '12px',
    color: theme.colors.primary,
    whiteSpace: 'normal',
    ' strong': {
      color: theme.colors.secondary
    }
  }),

  menuItem: generateCSS({
    display: 'block',
    width: '100%',
    padding: '6px 12px',
    border: 'none',
    background: 'none',
    textAlign: 'left',
    cursor: 'pointer',
    font: 'inherit',
    color: 'inherit',
    ':hover': {
      backgroundColor: theme.colors.selected
    },
    ':focus': {
      backgroundColor: theme.colors.selected,
      outline: 'none'
    }
  }),

  suggestion: generateCSS({
    fontWeight: 'bold'
  }),

  menuEmpty: generateCSS({
    padding: '6px 12px',
    fontStyle: 'italic',
    color: theme.colors.primary
  }),

  menuDivider: generateCSS({
    height: '1px',
    margin: '4px 0',
    backgroundColor: theme.colors.quaternary
  })
});

export default styleGenerator;
